//* 직전에 탭한 1건만 상세 진입에 쓰이므로 단일 슬롯
export const createEntryPreviewStore = <TPreview>() => {
  let lastTapped: TPreview | null = null;
  const listeners = new Set<() => void>();

  const emit = () => {
    listeners.forEach((listener) => {
      listener();
    });
  };

  const remember = (preview: TPreview) => {
    lastTapped = preview;
    emit();
  };

  const clear = () => {
    lastTapped = null;
    emit();
  };

  const subscribe = (listener: () => void) => {
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  };

  const getSnapshot = () => lastTapped;

  return { remember, clear, subscribe, getSnapshot };
};

//* 카드가 실제로 그린 srcset 후보 URL 그대로여야 상세에서 브라우저 캐시로 즉시 나온다
export const readTappedThumbnail = (element: Element) =>
  (
    element.querySelector('img') ??
    element.closest('article')?.querySelector('img')
  )?.currentSrc || undefined;
